document.documentElement.classList.remove('no-js');

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.quick-add-form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Toegevoegd ✓';
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('add failed');
    const cart = await fetch('/cart.js').then((result) => result.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  } catch (error) {
    form.submit();
    return;
  }
  window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1400);
});
